import * as React from "react";
import { FixedSizeList, ListChildComponentProps } from "react-window";
import { CircularProgress, Box } from "@mui/material";

const LISTBOX_PADDING = 8;

function renderRow(props: ListChildComponentProps) {
  const { data, index, style } = props;
  const item = data[index];

  if (item?.type === "loading") {
    return (
      <Box
        style={{ ...style, top: (style.top as number) + LISTBOX_PADDING }}
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100%"
      >
        <CircularProgress size={20} />
      </Box>
    );
  }

  return React.cloneElement(item, {
    style: {
      ...style,
      top: (style.top as number) + LISTBOX_PADDING,
      height: "auto",
      overflow: "visible",
    },
  });
}

const VirtualizedListboxComponent = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLElement> & { hasMore?: boolean; loading?: boolean }
>(function ListboxComponent(props, ref) {
  const { children, hasMore, loading, ...other } = props;

  const items = React.Children.toArray(children);
  const showLoading = hasMore && loading;

  const itemData = showLoading ? [...items, { type: "loading" }] : items;

  const itemCount = itemData.length;
  const itemSize = 60;
  const height = Math.max(100, Math.min(8, itemCount) * itemSize + 2 * LISTBOX_PADDING);

  const scrollOffsetRef = React.useRef(0);

  const handleScroll = ({ scrollOffset }) => {
    scrollOffsetRef.current = scrollOffset;
  };

  return (
    <div ref={ref} {...other}>
      <FixedSizeList
        height={height}
        width="100%"
        itemSize={itemSize}
        itemCount={itemCount}
        itemData={itemData}
        overscanCount={20}
        onScroll={handleScroll}
        initialScrollOffset={scrollOffsetRef.current}
        style={{ overflowX: "hidden" }}
      >
        {renderRow}
      </FixedSizeList>
    </div>
  );
});

export default VirtualizedListboxComponent;
